import { render } from "./LegalSources.vue?vue&type=template&id=75dd9b18&scoped=true"
import script from "./LegalSources.vue?vue&type=script&lang=js"
export * from "./LegalSources.vue?vue&type=script&lang=js"

import "./LegalSources.vue?vue&type=style&index=0&id=75dd9b18&scoped=true&lang=css"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75dd9b18"]])

export default __exports__